// extracted by mini-css-extract-plugin
export default {"button":"AppropriatenessTestTakeTestForm_button__W-Atg","wrapper":"AppropriatenessTestTakeTestForm_wrapper__73rwV"};